import { useTheme } from "@mui/styles";
import React from "react";
import styled from "styled-components";

import { RegularGreenOval } from "../StaticOurCommitment/OurCommitment.styles";
import { StyledDivWithRadius } from "./WhyEvrbed.styles";
import { useTranslation } from "react-i18next";

import {
  BlueLeafSmall,
  BuyAnotherBed,
  NeverImg,
  SquareOfSquaresSmall,
  TreeDeciduousRegularSmall,
  UserGearRegularSmall,
  YesWeMeanIt,
} from "./WhyEvrbed.images";

import BigBackgroundText from "../../components/TextComponents/BigBackgroundText";
import HeadlineText from "../../components/TextComponents/HeadlineText";
import {useHorizontalScroll} from "../../utils/browser.utils";

const SlideContainer = styled(StyledDivWithRadius)`
  flex-direction: row;
`;

const StyledRegularGreenOval = styled(RegularGreenOval)`
  position: inherit;
  transform: rotate(90deg);
  min-height: 272px;
  min-width: 200px;
  margin: 0 0 0 32px;
`;

const NeverBuyAnotherBed = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <SlideContainer className="col-3" backgroundColor={"transparent"}>
      <Sidebar>
        <StyledRegularGreenOval />
        <BlueLeafSmall />
      </Sidebar>
      <Content>
        <NeverBuyAnotherBedContainer>
          <BigBackgroundText
            className="text-center"
            text={t("never")}
          ></BigBackgroundText>
          <HeadlineText text={t("buy another bed")}></HeadlineText>
          <HeadlineText
            styles={{
              fontSize: "2.2rem",
              fontWeight: "400",
              marginTop: "40px",
              fontFamily: "noto-sans",
            }}
            text={t("(yes, we mean it).")}
          ></HeadlineText>
          {/*<NeverImg />*/}
          {/*<BuyAnotherBed />*/}
          {/*<YesWeMeanIt />*/}
        </NeverBuyAnotherBedContainer>
        <ItemsContainer>
          <Item>
            <SquareOfSquaresSmall />
            <Paragraph theme={theme}>
              {t(
                "evrbed's are the only mattress on the market where you can replace and change components as needed to evolve and extend the mattress lifecycle."
              )}
            </Paragraph>
          </Item>
          <Item>
            <UserGearRegularSmall />
            <Paragraph theme={theme}>
              {t(
                "Personalizing your evrbed means it fits each sleepers needs, for optimum comfort and more support. Oh, and sleep better!"
              )}
            </Paragraph>
          </Item>
          <Item>
            <TreeDeciduousRegularSmall />
            <Paragraph theme={theme}>
              {t(
                "If you don't need to buy mattresses every 7 years, you don't need to throw away a mattress every seven years. Old world quality is much more sustainable."
              )}
            </Paragraph>
          </Item>
        </ItemsContainer>
      </Content>
    </SlideContainer>
  );
};

const Paragraph = styled.p`
  font-size: 26px;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  padding-top: 50px;
`;

const Sidebar = styled.div`
  position: absolute;
`;

const Content = styled.div`
  margin-left: 220px;
  flex-direction: column;
  width: 100%;
`;

const NeverBuyAnotherBedContainer = styled.div`
  justify-content: start;
  max-height: 390px;
  max-width: 676px;
`;

const ItemsContainer = styled.div`
  flex-direction: row;
  padding: 70px 0 0 100px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
`;

const Item = styled.div`
  flex-direction: column;
  max-width: 340px;
`;

export default NeverBuyAnotherBed;
